{
  "title": "報名資料顯示「需補填」怎麼辦",
  "description": "說明「報名資料需補填」出現的原因、在哪裡看得到，以及如何補填；補填不會改變你的隊伍或報名狀態。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，你的報名資料重新符合目前的報名表單，「需補填」標示會消失。",
  "roleNote": "參賽者",
  "prerequisites": ["已加入或建立隊伍且已儲存過報名資料", "該場競賽的報名時間尚未截止"],
  "pathLabel": "我的競賽／首頁 → 競賽頁 → 報名資料",
  "steps": [
    {
      "title": "1. 認出「需補填」的提示",
      "description": "你已儲存的答案不符合目前已發布的報名表單時，「我的競賽」卡片會顯示「報名（需補填）」，首頁的待辦會多一筆補填提醒，競賽頁的報名資料卡片也會顯示「報名資料需補填」與尚缺的欄位名稱。常見原因：主辦方改版表單並新增必填欄位，或必填的勾選框（例如「團隊聲明」）沒有勾選。"
    },
    {
      "title": "2. 開啟並補齊欄位",
      "description": "在競賽頁的「報名資料」卡片點擊「補填報名資料」，畫面會標示缺少的欄位；補齊後按「儲存變更」。系統不會替你勾選任何聲明，你必須自己確認並勾選。"
    },
    {
      "title": "3. 確認標示消失",
      "description": "儲存成功後，卡片、首頁與競賽頁的「需補填」標示會消失。若主辦方有寄補填提醒 Email，收到信也可以直接從信中的連結進入競賽頁。"
    }
  ],
  "afterward": [
    "「需補填」只是提醒，不會改變你的隊伍、報名或作品進度",
    "請在報名截止前完成；截止後無法再儲存",
    "若仍顯示需補填，請確認是否有尚未勾選的必填勾選框或新增的必填欄位"
  ],
  "nextSteps": "接著可以前往作品繳交，準備要提交的作品。",
  "faq": [
    {
      "q": "我的報名會被取消嗎？",
      "a": "不會。「需補填」只是顯示提醒，系統不會取消報名，也不會變更你的隊伍或作品狀態。"
    },
    {
      "q": "為什麼我明明已經報名完成，還要補填？",
      "a": "報名完成後，主辦方可能改版報名表單（例如新增必填欄位）。舊的答案沒有新欄位，或必填勾選框沒有勾選時，就會被標示為需補填。"
    },
    {
      "q": "怎麼確認主辦方寄來的補填提醒 Email 是真的？",
      "a": "信件的收件人只會是你本人，內文只列出尚缺的欄位名稱，不會索取密碼或任何個資，信末附有競賽的主辦單位聯絡信箱。請直接從平台網站登入後補填，不要點選來路不明的連結，也不要回覆密碼。"
    },
    {
      "q": "補填時沒有看到「補填報名資料」按鈕？",
      "a": "報名截止後無法再儲存，按鈕不會出現；請以競賽頁顯示的目前輪次報名截止時間為準，並向主辦單位聯絡信箱洽詢。"
    }
  ]
}
